import styled, { css } from "styled-components";
import theme from "styled-theming";

const inputClient = theme("client", {
  mapfre: css`
    background: #fff;
    padding: 8px;
    margin: 15px auto 0 auto;
    min-height:0;
    border-radius:0;
  `
});

const buttonClient = theme.variants("client", "variant", {
  forgotPw: {
    mapfre: css`
      background: transparent;
      color: white;
    `,
    bankia: css`color:${props => props.theme.themeGlobal.textColor};`
  },
  default: {
    mapfre: css`
      border-bottom: 2px solid #562894;
      background-color: ${props => props.theme.themeGlobal.main};
    `,
    bankia: css`
      background-color: ${props => props.theme.themeGlobal.main};
      color: ${props => props.theme.themeGlobal.textColorSecondary};
      margin-top: 8px;`
  },
  inverse: {
    mapfre: css`
      background: transparent;
      color: #fff;
      border: 2px solid #fff;
      font-weight:normal;
    `,
    bankia: css`
      border: 1px solid ${props => props.theme.themeGlobal.third};
      color: ${props => props.theme.themeGlobal.textColorSecondary};`
  }
});

const HeadingStyleClient = theme("client", {
  mapfre: css`color: #fff;`
});

const clientCheckBox = theme('client', {
  bankia: css`border:2px solid #aaa`
});

const SubheadingStyleClient = theme("client", {
  mapfre: css`
    color: #fff;
    max-width: 300px;
    margin: 15px auto 5px auto;
  `
});

const linkColorClient = theme("client", {
  mapfre: '#fff'
});

export const Required = styled.p`
  color:${props => props.theme.themeGlobal.negative};
  font-weight:bold;font-size: 13px;
`;

export const Heading = styled.h3`
  color:${props => props.theme.themeGlobal.main};
  margin-bottom:10px;
  ${HeadingStyleClient}
  @media only screen and (max-width: 1024px) and (orientation: landscape) {
    font-size:1.5rem;
  }
`;

export const Input = styled.input`
  background: #fff;
  padding:0 8px;
  margin: 5px auto 0 auto;
  display:block;
  width:100%;
  color:${props => props.theme.themeGlobal.textColor};
  line-height: 118%;
  border-radius: 4px;
  border: 1px solid #AAA;min-height:40px;
  ${inputClient};
  @media only screen and (max-width: 1024px) and (max-height: 400px) and (orientation: landscape) {
    min-height: 30px;
  }
`;

export const Button = styled.button`
  color: #fff;
  padding: 12px 10px;
  width: 100%;
  max-width:300px;
  margin-right:3px;
  margin-bottom:5px;
  background-color: ${props => props.theme.themeGlobal.main};
  border: 1px solid ${props => props.theme.themeGlobal.main};
  border-radius: ${props => props.theme.themeGlobal.borderRadiusSecondary};
  &.inverse{
    border: 2px solid ${props => props.theme.themeGlobal.main};
    background:transparent;
    color: ${props => props.theme.themeGlobal.main};
    }
  &.forgotPw{
    background:transparent;
    color: ${props => props.theme.themeGlobal.main};
    border:0;
    max-width:none;
    padding-left:0;
    text-align:left;
    text-decoration: underline;
    font-weight:normal;}
  &.help{padding:5px; border-radius:4px; background: #b74d6b;font-size:10px; border: 0;
    margin:8px auto 5px auto;min-width: 0;display: block;}
    &.inverse,&.forgotPw,&.help{
  ${buttonClient};}

  @media only screen and (max-width: 1024px) and (orientation: landscape) {
    padding: 8px 5px;
    margin: 5px;
    &.forgotPw{padding: 5px 0;}
  }
`;

export const HelpBlockAddition = styled.p`
    text-align: right;
    background: #dfc6cd;
    margin: 0;
    margin-top: -8px;
    padding-bottom: 3px;
`

Button.defaultProps = { variant: "default" };

export const SubHeading = styled.p`
  margin-top:18px;
  color: ${props => props.theme.themeGlobal.textColor};
  ${SubheadingStyleClient}
`;

export const LabelRadio = styled.div`
  display: block;
  text-align: center;
  margin: 0 auto;
  color: ${props => props.theme.themeGlobal.third};
  color: ${linkColorClient};
  position: relative;
  
  > label {
    position: relative;
    display: inline-block;
    margin-right: 15px;
    margin-top: 8px;
    height: 25px;
    padding-left: 35px;
    padding-top: 5px;
    text-align: right;
  }
  > label input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  > label .customRadio {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 50%;
    display: inline-block;
    border:2px solid #aaa;
    ${clientCheckBox};
  }
  > label span.customRadio:after {
    content: "";
    position: absolute;
    display: none;
    top: 6px;
    right:6px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: white;
  }

  > label:hover input ~ .customRadio {
    background-color: #ccc;
  }

  > label input:checked ~ .customRadio {
    background-color: ${props => props.theme.themeGlobal.main};
  }

  > label input:checked ~ .customRadio:after {
    display: block;
  }
`;

export const Checkbox = styled.div`
  margin: 5px auto 20px auto;
  > label a:link,
  > label a:visited,
  > label a:hover,
  > label a:active {
    font-size: 12px;
    color: ${props => props.theme.themeGlobal.third};
    color: ${linkColorClient};
  }
  > label {
    position: relative;
    display: inline-block;
    margin-right: 15px;
    margin-top: 8px;
    padding-top: 2px;
    text-align: right;
    padding-left: 30px;
  }

  > label input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  > label .customCheck {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 3px;
    display: inline-block;
    border: 2px solid #aaa;
  }
  > label span.customCheck:after {
    content: "";
    position: absolute;
    display: none;
    top: 7px;
    left: 7px;
    width: 10px;
    height: 10px;
    left: 9px;
    top: 4px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  > label:hover input ~ .customCheck {
    border: 1px solid ${props => props.theme.themeGlobal.bgNeutral};
    background-color: #fff;
  }

  > label input:checked ~ .customCheck {
    background-color: ${props => props.theme.themeGlobal.main};
  }

  > label input:checked ~ .customCheck:after {
    display: block;
  }

  @media only screen and (max-width: 1024px) and (orientation: landscape) {
    margin: 5px auto;
  }
`;